import React from 'react';
import { connect } from 'react-redux';
import classes from './Header.module.scss';
import { Link } from 'react-router-dom';
import { loginedSelector } from '../../Redux/Reducers/authReducer';
import { userSelector } from '../../Redux/Reducers/userReducer';
import { IUser } from '../../Utils/types';
import { ProfileAvatar } from './ProfileAvatar/ProfileAvatar';

interface StateProps {
  logined: boolean,
  user: IUser
}
interface DispatchProps { }
interface Props extends StateProps, DispatchProps { }

function Header(props: Props) {
  return (
    <div className={classes.Header}>
      <div className={classes.Logo}>
        <Link to={'/'}>Shoop</Link>
      </div>
      <nav>
        {
          props.logined
          && <ProfileAvatar avatarURL={props.user.avatar} />
        }
      </nav>
    </div>
  );
}
function mapStateToProps(state: any) {
  return {
    logined: loginedSelector(state),
    user: userSelector(state)
  }
}

const connectedHeader = connect(mapStateToProps)(Header);
export { connectedHeader as Header };